namespace AgerLMS.Logging {
    export interface CheckUserForRegisterSMSRequest<TEntity> extends Serenity.SaveRequest<TEntity> {
        Recaptcha?: string;
    }
}
